<template>
    <div :class="$style.icons">
        <PayPal />
    </div>
</template>

<script>
import PayPal from "../shapes/paypal";

export default {
    name: "PaypalPaymentBlockIcons",
    components: {
        PayPal
    }
};
</script>

<style lang="postcss" module>
    .icons {
        display: flex;
        margin-top: 0;
        align-items: center;
    }

    .icons > svg {
        width: 130px;
        height: 55px;
    }

    .icons > svg:not(:last-child) {
        margin-right: 12px;
    }
</style>
